<template>
  <div class="about-wrap">
    <el-row :gutter="14">
      <el-col :span="12">
        <div>
          <nk-box-title :title="'当前版本：' + version.version">
            <div
              slot="title"
              class="txt-blue pointer"
              style="background: #3f9efe;"
              @click="hreftwo"
            >
              查看版本更新记录
            </div>
            <div class="box-content">
              <div class="txt-blue update">
                更新时间：{{ version.date }}
                <!-- <div class="logo">
                  <img src />
                </div> -->
              </div>
              <div
                style="color: #000;padding: 4px 0px;"
                v-html="version.remark"
              ></div>
            </div>
          </nk-box-title>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <nk-box-title :title="'联系我们'">
            <div class="box-content">
              <div class="txt-blue update">广州耐奇电气科技有限公司</div>
              <div class="item">
                <i class="iconfont icon-dianhua"></i>
                <label>电话：020-28065055</label>
              </div>
              <div class="item">
                <i class="iconfont icon-chuanzhen"></i>
                <label>传真：020-28065009</label>
              </div>
              <div class="item">
                <i class="iconfont icon-youxiang"></i>
                <label>邮箱：nikey_gz@nikeychina.com</label>
              </div>
              <div class="item">
                <i class="iconfont icon-wangzhi"></i>
                <label>网址：http://www.nikey-elec.com/</label>
              </div>
              <div class="item">
                <i class="iconfont icon-dizhi"></i>
                <label
                  >地址：广州市-高新技术开发区科学城科学大道182号创新大厦C1栋第8层</label
                >
              </div>
              <!-- <div class="item">
                <i class="iconfont icon-dianhua"></i>
                <label>硬件咨询：</label>
              </div>
              <div class="item">
                <i class="iconfont icon-dianhua"></i>
                <label>软件咨询：</label>
              </div> -->
            </div>
          </nk-box-title>
        </div>
      </el-col>
    </el-row>
    <div style="display:none">
      <el-row style="margin-top:14px">
        <el-col :span="24">
          <div style="width:100%;height:100%">
            <nk-box-title :title="'相关资料'">
              <div class="bottom-content">
                <el-row :gutter="10">
                  <el-col :span="4">
                    <div class="boxbottom" v-if="imgshow">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-tupian"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="boxbottom" v-if="Wordshow">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-Excel"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="boxbottom" v-if="Excelshow">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-word"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="boxbottom" v-if="PDFshow">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-PDF"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="boxbottom">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-huanjingzhuangtai1"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="boxbottom">
                      <div class="boxbottomcontent">
                        <span class="iconfont icon-huanjingzhuangtai1"></span>
                      </div>
                      <div class="midbottomcontent">
                        <p>
                          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                        </p>
                      </div>
                      <div class="bottombottomcontent" @click="download">
                        下载
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <!-- <div class="bottomcontent">
                <div class="topbottomcontent">
                  <span class="iconfont icon-huanjingzhuangtai1"></span>
                </div>
                <div class="midbottomcontent">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
                <div class="bottombottomcontent" @click="download">下载</div>
              </div>
              <div class="bottomcontent">
                <div class="topbottomcontent">
                  <span class="iconfont icon-huanjingzhuangtai1"></span>
                </div>
                <div class="midbottomcontent">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
                <div class="bottombottomcontent" @click="download">下载</div>
              </div>
              <div class="bottomcontent">
                <div class="topbottomcontent">
                  <span class="iconfont icon-huanjingzhuangtai1"></span>
                </div>
                <div class="midbottomcontent">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
                <div class="bottombottomcontent" @click="download">下载</div>
              </div>
              <div class="bottomcontent">
                <div class="topbottomcontent">
                  <span class="iconfont icon-huanjingzhuangtai1"></span>
                </div>
                <div class="midbottomcontent">XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
                <div class="bottombottomcontent" @click="download">下载</div>
              </div>-->
              </div>
            </nk-box-title>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import NkBoxTitle from "@/components/common/NkBoxTitle";
export default {
  components: { NkBoxTitle },
  data() {
    return {
      version: window.version[0],
      ifLoad: true,
      name: "",
      contactPhoneNumber: "",
      contactEmail: "",
      address: "",
      imgshow: false,
      Wordshow: false,
      Excelshow: false,
      PDFshow: false,
    };
  },
  created() {
    this.getData();
    this.init();
  },
  activated() {},
  methods: {
    getData() {
      // this.$api.company.getCompanyLogo(0).then((res) => {
      //   console.log(res);
      // });
      // this.$api.company.getCompanyInfo(0).then((res) => {
      //   console.log(res);
      //   this.ifLoad = false;
      //   this.name = res.data.name;
      //   this.contactPhoneNumber = res.data.contactPhoneNumber;
      //   this.contactEmail = res.data.contactEmail;
      //   this.address = res.data.address;
      // });
    },
    init() {
      this.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          this.$store.state.user.currentCompanyId,
          "/About",
          null
        )
        .then((res) => {
          console.log(res);
          if (!res) return;

          let data = JSON.parse(res.data[0].value);

          this.imgshow = this.arrHasValue("img", data);
          this.Wordshow = this.arrHasValue("Word", data);
          this.Excelshow = this.arrHasValue("Excel", data);
          this.PDFshow = this.arrHasValue("PDF", data);
          console.log(this.imgshow);
        });
    },
    //判断有没有这个值
    arrHasValue(v, arr) {
      var output = false;
      for (var i in arr) {
        if (v == arr[i]) {
          output = true;
          return output;
        }
      }
      output = false;
      return output;
    },
    tableSelectChange() {},
    hreftwo() {
      this.$router.push({ path: "/Version" });
    },
    download() {
      console.log("111");
    },
  },
};
</script>

<style lang="scss" scoped>
.about-wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.box-content {
  background-color: #fff;
  width: 100%;
  height: 300px;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
}
.bottom-content {
  // display: flex;
  // justify-content: flex-start;
  background-color: #fff;
  // width: 100%;
  height: 300px;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  flex: 1;
  color: #000;
}
.title-content-right {
  background: #0096ed00 !important;
  .txt-blue {
    color: #ffffff !important;
  }
}
.boxbottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #f0f3f4;
  .boxbottomcontent {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0096ed;
    margin-top: 10px;
    background: #ecf1f2;
    height: 100px;
    width: 100px;
    line-height: 50px;
    border-radius: 100%;
    .iconfont {
      font-size: 60px;
    }
  }
  .midbottomcontent {
    margin-top: 20px;
    height: 100px;
    width: 80%;

    // text-overflow: ellipsis;
    // white-space: nowrap;
    // overflow: hidden;
    // margin-top: 20px;
    // width: 90%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
    }
  }
  .bottombottomcontent {
    display: flex;
    background: #0097ee;
    font-size: 30px;
    width: 100%;
    height: 30%;
    color: #ebf3fd;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.pointer {
  cursor: pointer;
}
.update {
  position: relative;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f3f4;
}
.logo {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 80px;
  height: 80px;
  background-color: #f0f3f4;
  border-radius: 40px;
  img {
    display: block;
    width: 50px;
    height: 50px;
    margin: 0px auto;
    margin-top: 15px;
  }
}
.item {
  padding: 4px 0px;
  display: flex;
  align-items: center;
  color: #000;
  .iconfont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background: #ecf1f2;
    color: #0097ee;
    border-radius: 50%;
  }
  label {
    padding-left: 6px;
  }
}
.bottomcontent {
  color: #000;
  display: flex;
  flex-direction: column;
  border: 1px solid #e3e3e3;
  justify-content: space-between;
  //flex-wrap:wrap
  align-items: center;
  height: 100%;
  width: 100%;
  margin-right: 10px;
  .topbottomcontent {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0096ed;
    margin-top: 10px;
    background: #ecf1f2;
    height: 100px;
    width: 100px;
    line-height: 50px;
    border-radius: 100%;

    .iconfont {
      font-size: 5rem !important;
    }
  }
  .midbottomcontent {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bottombottomcontent {
    display: flex;
    background: #0097ee;
    font-size: 30px;
    width: 100%;
    height: 25%;
    color: #ebf3fd;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.bottomcontent:last-child {
  color: #000;
  display: flex;
  flex-direction: column;
  border: 1px solid #e3e3e3;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-right: 0px;
  .topbottomcontent {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0096ed;
    margin-top: 10px;
    background: #ecf1f2;
    height: 100px;
    width: 100px;
    line-height: 50px;
    border-radius: 100%;

    .iconfont {
      font-size: 5rem !important;
    }
  }
  .midbottomcontent {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bottombottomcontent {
    display: flex;
    background: #0097ee;
    font-size: 30px;
    width: 100%;
    height: 25%;
    color: #ebf3fd;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
